import comparePopupsByDocumentPosition from './comparePopupsByDocumentPosition';

const sortByDocumentPosition = popups =>
  Object.values(popups).sort(comparePopupsByDocumentPosition);

export default sortByDocumentPosition;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/sortByDocumentPosition.jsx